/* ZISTY HOME — sets de table
   Calcule les quantités selon le nombre de convives (guest = un par convive, fixed:N = N pour la table,
   lot:N = un pour N convives), affiche la remise sets et ajoute toutes les pièces au panier en un clic. */
if (!customElements.get('zisty-set')) {
  class ZistySet extends HTMLElement {
    connectedCallback() {
      const d = this.dataset;
      this.fmt = new Intl.NumberFormat(d.locale || 'fr-BE', { style: 'currency', currency: d.currency || 'EUR' });
      this.rules = [
        [parseInt(d.min2, 10) || 0, parseFloat(d.rate2) || 0],
        [parseInt(d.min1, 10) || 0, parseFloat(d.rate1) || 0],
      ].filter((r) => r[0] > 0 && r[1] > 0).sort((a, b) => b[0] - a[0]);
      this.free = parseInt(d.free, 10) || 0;
      this.items = [...this.querySelectorAll('[data-item]')];
      this.addEventListener('change', () => this.update());
      const btn = this.querySelector('[data-add]');
      if (btn) btn.addEventListener('click', () => this.add());
      this.update();
    }

    guests() {
      const g = this.querySelector('input[data-guests]:checked');
      return g ? parseInt(g.value, 10) : parseInt(this.dataset.guests, 10) || 6;
    }

    qty(mode, guests) {
      const [kind, n] = String(mode || 'fixed:1').split(':');
      const num = Math.max(1, parseInt(n, 10) || 1);
      if (kind === 'guest') return guests;
      if (kind === 'lot') return Math.ceil(guests / num);
      return num;
    }

    money(cents) {
      return this.fmt.format(cents / 100);
    }

    text(sel, value) {
      this.querySelectorAll(sel).forEach((el) => {
        el.textContent = value;
      });
    }

    included(li) {
      const box = li.querySelector('input[type="checkbox"]');
      return !box || box.checked;
    }

    update() {
      const guests = this.guests();
      let pieces = 0;
      let sub = 0;
      this.items.forEach((li) => {
        const on = this.included(li);
        const q = this.qty(li.dataset.mode, guests);
        const line = q * (parseInt(li.dataset.price, 10) || 0);
        li.classList.toggle('is-off', !on);
        const qe = li.querySelector('[data-qty]');
        if (qe) qe.textContent = `× ${q}`;
        const le = li.querySelector('[data-line]');
        if (le) le.textContent = this.money(line);
        if (on) {
          pieces += q;
          sub += line;
        }
      });
      const rule = this.rules.find((r) => pieces >= r[0]);
      const disc = rule ? Math.round((sub * rule[1]) / 100) : 0;
      const total = sub - disc;
      const next = [...this.rules].reverse().find((r) => pieces < r[0]);
      this.text('[data-pcs]', pieces);
      this.text('[data-sub]', this.money(sub));
      this.text('[data-total]', this.money(total));
      this.text('[data-disc]', rule ? `−${this.money(disc)}` : '—');
      this.text('[data-disc-label]', rule ? `Remise sets −${rule[1]} %` : next ? `Remise sets dès ${next[0]} pièces` : 'Remise sets');
      this.querySelectorAll('[data-was]').forEach((el) => {
        el.hidden = !rule;
      });
      if (this.free) {
        this.text('[data-ship]', total >= this.free ? 'Livraison offerte' : `Plus que ${this.money(this.free - total)} pour la livraison offerte`);
      }
      const btn = this.querySelector('[data-add]');
      if (btn) btn.disabled = pieces === 0;
    }

    async add() {
      const guests = this.guests();
      const items = this.items
        .filter((li) => this.included(li))
        .map((li) => ({ id: parseInt(li.dataset.variant, 10), quantity: this.qty(li.dataset.mode, guests) }))
        .filter((i) => i.id && i.quantity > 0);
      if (!items.length) return;
      const btn = this.querySelector('[data-add]');
      const msg = this.querySelector('[data-msg]');
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      if (msg) msg.textContent = 'Ajout au panier…';
      try {
        const res = await fetch(`${this.dataset.cartAdd || '/cart/add'}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        });
        const data = await res.json().catch(() => ({}));
        if (!res.ok) throw new Error(data.description || data.message || 'Ajout impossible pour le moment.');
        window.location.href = this.dataset.cart || '/cart';
      } catch (err) {
        if (msg) msg.textContent = `${err.message} Ajustez le nombre de convives ou ajoutez les pièces une à une.`;
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
      }
    }
  }
  customElements.define('zisty-set', ZistySet);
}
